import React, { useState, useEffect } from 'react'
import Typography from '@mui/material/Typography';
import InvestorStyles from './Investor.module.css';
import { Box, Button } from '@mui/material';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { Link } from 'react-router-dom';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import axios from 'axios';

export const Investor = () => {


    const [highlightData, setHighlightData] = useState();
    const [companyData, setCompanyData] = useState();
    const [investorData, setInvestorData] = useState();


    const formatDate = (date) => {
        return date ? new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' }).replace(/\//g, '.') : '';
    };

    // -----------------------------------------------------------------------------------



    const getHighlightsData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/investmentHighlights/getAllInvestmentHighlights`
            )
            setHighlightData(res.data);
            const dates = res.data.map((item) => {
                const [day, month, year] = item.highlights.date.split('.');
                return (
                    new Date(year, month - 1, day).getTime()
                )
            })
            const maxDate = new Date(Math.max(...dates));
            setHighlightData(maxDate);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getHighlightsData()
    }, [])


    // -----------------------------------------------------------------------------------



    const getCompanyData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/companydetails/getAllCompanyDetails`
            )
            setCompanyData(res.data)
            const dates = res.data.map((item) => {
                const [day, month, year] = item.companyDetails.date.split('.');
                return (
                    new Date(year, month - 1, day).getTime()
                )
            })
            const maxDate = new Date(Math.max(...dates));
            setCompanyData(maxDate);
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getCompanyData()
    }, [])


    // -----------------------------------------------------------------------------------


    const getinvestorData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSINV}/investmentOpportunities/getAllInvestmentOpportunities`
            )
            setInvestorData(res.data)
            const dates = res.data.map((item) => {
                const [day, month, year] = item.date.split('.');
                return (
                    new Date(year, month - 1, day).getTime()
                )
            })
            const maxDate = new Date(Math.max(...dates));
            setInvestorData(maxDate);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getinvestorData()
    }, [])



    return (
        <div className={InvestorStyles.investorMain}>
            <div className={InvestorStyles.investorContent}>
                <Typography sx={{ marginTop: '2%', color: '#121926', fontWeight: '600', fontSize: '20px', paddingBottom: '3%' }} >
                    Investor
                </Typography>
                <Box className={InvestorStyles.investorComponent}>
                    <div className={InvestorStyles.investorComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Title
                        </Typography>
                    </div>
                    <div className={InvestorStyles.investorComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Last modified
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Action
                        </Typography>
                    </div>
                </Box>
                <Box className={InvestorStyles.investorComponent}>
                    <div className={InvestorStyles.investorComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Investment Highlights
                        </Typography>
                    </div>
                    <div className={InvestorStyles.investorComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px' }}>
                            {formatDate(highlightData)}
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            <Link to='/investment'>
                                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                            </Link>
                        </Typography>
                    </div>
                </Box>
                <Box className={InvestorStyles.investorComponent}>
                    <div className={InvestorStyles.investorComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Company Details
                        </Typography>
                    </div>
                    <div className={InvestorStyles.investorComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px' }}>
                            {formatDate(companyData)}
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            <Link to='/companydetails'>
                                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                            </Link>
                        </Typography>
                    </div>
                </Box>
                <Box className={InvestorStyles.investorComponent}>
                    <div className={InvestorStyles.investorComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Investment opportunities
                        </Typography>
                    </div>
                    <div className={InvestorStyles.investorComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px' }}>
                            {formatDate(investorData)}
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            <Link to='/InvestmentOpp'>
                                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                            </Link>
                        </Typography>
                    </div>
                </Box>
            </div>
        </div>
    )
}

export default Investor